import { render } from "./TripDurationMenu.vue?vue&type=template&id=4064c2af"
import script from "./TripDurationMenu.vue?vue&type=script&lang=js"
export * from "./TripDurationMenu.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__